import { render, staticRenderFns } from "./LiveStreamingPlayer.vue?vue&type=template&id=2436fce6&"
import script from "./LiveStreamingPlayer.vue?vue&type=script&lang=js&"
export * from "./LiveStreamingPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports